<template>
  <div class="page-container">
    <transaction-grid></transaction-grid>
  </div>
</template>

<script>
import TransactionGrid from '@/components/grid/TransactionGrid.vue';

export default {
  components: {
    TransactionGrid,
  },
};

</script>

<style lang="scss" scoped>

</style>
